export default {
  "orderTask.title": "【 One-click order 】 My order task",
  "orderTask.projectOrderTask": "Project order task",
  "orderTask.factoryOrder": "Factory order",
  "orderTask.search": "Search",
  "orderTask.operate": "Operate",
  "orderTask.taskCreationTime": "Task creation time",
  "orderTask.taskEndTime": "Task end time",
  "orderTask.taskStatus": "Task status",
  "orderTask.edit": "Edit",
  "orderTask.splitOrderDetails": "Split order details",
  "orderTask.oneClickOrder": "One-click order",
  "orderTask.delete": "Delete",
  "orderTask.reassign": "Reassign",
  "orderTask.associatedSourceFile": "Associated source file",
  "orderTask.masterContractNumber": "Master contract number",
  "orderTask.orderTaskId": "Order task ID",
  "orderTask.remarks": "Remarks",
  "orderTask.completedTotal": "Completed/Total number of spliting order",
  "orderTask.currentResponsible": "Current responsible person",
  "orderTask.splitOrderDetails": "Split order details",
  "orderTask.fullOrderSplitting": "Full order splitting",
  "orderTask.simpleOrderSplitting": "Simple order splitting",
  "orderTask.NO": "NO.",
  "orderTask.cancel": "Cancel",
  "orderTask.redo": "Redo",
  "orderTask.affiliated": "Affiliated combination cabinet",
  "orderTask.taskId": "Task ID",
  "orderTask.orderName": "Order name",
  "orderTask.taskType": "Task type",
  "orderTask.splitDocument": "Split document",
  "orderTask.showMore": "Show more",
  "orderTask.fold": "Fold",
  "orderTask.taskCreator": "Task creator",
  "orderTask.saved": "Saved",
  "orderTask.splittingTheOrder": "Splitting the order",
  "orderTask.successfullySplit": "Successfully split the order",
  "orderTask.failedSplit": "Failed split the order",
  "orderTask.ordered": "Ordered",
  "orderTask.FailedOrder": "Failed to place an order",
  "orderTask.placingOrder": "Placing an order",
  "orderTask.canceled": "Canceled",
  "orderTask.yes": "Yes",
  "orderTask.cancel": "Cancel",
  "orderTask.save": "Save",
  "orderTask.mtdsFactoryOrder": "MTDS Factory order",
  "orderTask.orderNumber": "Order number",
};



// WEBPACK FOOTER //
// ./src/locales/lang/en-US/orderTask/settings.js